import React from 'react';
import { Github, Linkedin, Twitter, Youtube, Cloud, Award, Lock } from 'lucide-react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Experience from '../components/Experience';
import Projects from '../components/Projects';
import Skills from '../components/Skills';
import Certifications from '../components/Certifications';
import Contact from '../components/Contact';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <About />
      <Experience />
      <Projects />
      <Skills />
      <Certifications />
      <Contact />
      
      <footer className="py-12 bg-gray-50 dark:bg-[#1c1c1e] border-t border-gray-100 dark:border-gray-800 transition-colors duration-300">
        <div className="container mx-auto px-6 max-w-7xl">
          <div className="flex flex-col md:flex-row justify-between items-center gap-8 mb-12">
            <div className="text-center md:text-left">
              <h3 className="text-2xl font-bold text-gray-900 dark:text-white font-inter">Harsh Murjani</h3>
              <p className="text-gray-500 dark:text-gray-400 font-inter mt-1">Cybersecurity & Software Development Engineer</p>
            </div>

            <div className="flex flex-wrap justify-center gap-4">
              {[
                { name: 'LinkedIn', href: 'https://www.linkedin.com/in/harsh-murjani/', icon: <Linkedin size={18} /> },
                { name: 'GitHub', href: 'https://github.com/hm05', icon: <Github size={18} /> },
                { name: 'Twitter/X', href: 'https://x.com/murjani_harsh/', icon: <Twitter size={18} /> },
                { name: 'YouTube', href: 'https://youtube.com/@Cyber-Verse', icon: <Youtube size={18} /> },
                { name: 'Google Cloud', href: 'https://www.cloudskillsboost.google/public_profiles/6e1eb6d9-b7fc-4724-beea-dd5c1cbb5e32', icon: <Cloud size={18} /> },
                { name: 'Credly', href: 'https://www.credly.com/users/harsh-murjani/badges', icon: <Award size={18} /> },
                { name: 'TryHackMe', href: 'https://tryhackme.com/p/harshmurjani', icon: <Lock size={18} /> }
              ].map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-3 rounded-xl bg-white dark:bg-black border border-gray-100 dark:border-gray-800 text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 hover:border-blue-100 dark:hover:border-blue-900/30 transition-all duration-300"
                  aria-label={social.name}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          <div className="pt-8 border-t border-gray-100 dark:border-gray-800 text-center">
            <p className="text-gray-400 dark:text-gray-500 font-inter text-sm">
              © {new Date().getFullYear()} Harsh Murjani. Built with precision and security in mind.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;
